/* ============================================================
   FOOTWRK CUSTOM JS
   Hero slider, scroll reveals, drag-scroll, popup, nav shrink
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ===========================
  // HERO SLIDESHOW
  // ===========================
  const heroSlides = document.querySelectorAll('.fw-hero-slide');
  const heroProgress = document.querySelector('.fw-hero-progress');
  if (heroSlides.length > 0) {
    let currentSlide = 0;
    const SLIDE_INTERVAL = 5000;

    function goToSlide(n) {
      heroSlides[currentSlide].classList.remove('active');
      const bg = heroSlides[currentSlide].querySelector('.fw-hero-bg');
      if (bg) bg.style.transform = 'scale(1)';
      currentSlide = n % heroSlides.length;
      heroSlides[currentSlide].classList.add('active');
      // Reset progress bar
      if (heroProgress) {
        heroProgress.style.transition = 'none';
        heroProgress.style.width = '0%';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            heroProgress.style.transition = `width ${SLIDE_INTERVAL}ms linear`;
            heroProgress.style.width = '100%';
          });
        });
      }
    }

    // Start progress bar
    if (heroProgress) {
      heroProgress.style.transition = `width ${SLIDE_INTERVAL}ms linear`;
      heroProgress.style.width = '100%';
    }

    setInterval(() => goToSlide(currentSlide + 1), SLIDE_INTERVAL);
  }

  // ===========================
  // NAV SHRINK ON SCROLL
  // ===========================
  const header = document.querySelector('.header-wrapper') || document.querySelector('header');
  if (header) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          header.classList.toggle('scrolled', window.scrollY > 60);
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // ===========================
  // SCROLL REVEAL (IntersectionObserver)
  // ===========================
  const revealElements = document.querySelectorAll('.fw-fade-up, .fw-fade-left, .fw-fade-right');
  if (revealElements.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revealElements.forEach(el => observer.observe(el));
  }

  // ===========================
  // HORIZONTAL DRAG SCROLL (Categories)
  // ===========================
  const scroller = document.querySelector('.fw-cat-scroll');
  if (scroller) {
    let isDown = false, startX, scrollLeft;
    scroller.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - scroller.offsetLeft;
      scrollLeft = scroller.scrollLeft;
      scroller.style.cursor = 'grabbing';
    });
    scroller.addEventListener('mouseleave', () => { isDown = false; scroller.style.cursor = 'grab'; });
    scroller.addEventListener('mouseup', () => { isDown = false; scroller.style.cursor = 'grab'; });
    scroller.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - scroller.offsetLeft;
      scroller.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  }

  // ===========================
  // POPUP (after delay)
  // ===========================
  const popup = document.querySelector('.fw-popup-bg');
  if (popup) {
    // Check if already dismissed this session
    const dismissed = sessionStorage.getItem('fw-popup-dismissed');
    if (!dismissed) {
      setTimeout(() => popup.classList.add('show'), 4000);
    }

    const closeBtn = popup.querySelector('.fw-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        popup.classList.remove('show');
        sessionStorage.setItem('fw-popup-dismissed', '1');
      });
    }
    // Close on overlay click
    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        popup.classList.remove('show');
        sessionStorage.setItem('fw-popup-dismissed', '1');
      }
    });
  }

});
